// One palette. It was copy-pasted into App.jsx, hub/Dashboards.jsx and
// hub/Panel.jsx, which is fine until two of the three drift and the nav no
// longer matches the board it navigates to.
export const COLORS = {
    primary: '#3b82f6',
    success: '#10b981',
    warning: '#f59e0b',
    danger: '#ef4444',
    background: '#0f172a',
    cardBg: '#1e293b',
    cardHover: '#263548',
    text: '#f1f5f9',
    textMuted: '#94a3b8',
    border: '#334155',
    accent: '#8b5cf6',
}

export default COLORS
